$(document).ready(function(){
  // $("img.lazyload").lazyload();
  $(document).on("click", ".card--product .quick_view", function(event){
      event.preventDefault();
      var variant_id = $(this).attr("data-variant_id");
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: variant_id
        },
        dataType: 'json',           
        success: function() {
          jQuery.getJSON('/cart.js', function(cart) {
            if($('body').hasClass('customer_wholesale')){
              window.location.href = '/cart';
            }
            else{
              updateMinicart(cart);
              $('body').addClass("minicart-open");
            }
         })
        }});
  })

  // Function add to cart product upsell cart popup
  $(document).on("click", ".product__upsell__list__item .btn-add-to-cart-upsell", function(event){
    event.preventDefault();
    var variant_id = $(this).attr("data-variant_id");
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
          quantity: 1,
          id: variant_id
      },
      dataType: 'json',           
      success: function() {
        jQuery.getJSON('/cart.js', function(cart) {
          // $("body").addClass("minicart-open");
          updateMinicart(cart);
      })
    }});
})

  $(document).on("click", ".footer__content-top details summary", function(){
    var _this = $(this);
    var flag = false;
    console.log();
    if(_this.closest("details").attr("open") == "open") flag = true;
    $(this).closest(".footer__blocks-wrapper").find("details[open]").removeAttr("open");
    if(flag) {
      setTimeout(function(){
        _this.closest("details[open]").removeAttr("open");
      }, 100)
    }
  })

  $(document).on("click", ".cart__item .item_plus", function(){
    var num = parseInt($(this).closest(".qty__content").find(".qty_num").text()) + 1;
    var variant_id = $(this).closest(".cart__item").data("variant_id");
    var count = parseInt($(".item__count").text()) + 1;
    var currency_symbol = $(".totals__subtotal-value").data("symbol");
    var total = parseFloat( $(".totals__subtotal-value").attr("data-total_price"));
    console.log(total);
    var price = parseFloat($(this).closest(".cart__item").find('.item__price').data("price"));
    $.post('/cart/update.js', 'updates['+variant_id+']=' + num);
    $(this).closest(".qty__content").find(".qty_num").text(num);
    $(".item__count").text(count);
    $(".totals__subtotal-value").attr("data-total_price", (total + price));
    $(".totals__subtotal-value").text(currency_symbol + (total / 100 + price / 100).toFixed(2));
  })
  $(document).on("click", ".cart__item .item_minus", function(){
    var num = parseInt($(this).closest(".qty__content").find(".qty_num").text()) - 1;
    if (num == 0) {
      $(this).closest(".cart__item").find(".remove_item").click();
    } else {
      var variant_id = $(this).closest(".cart__item").data("variant_id");
      var count = parseInt($(".item__count").text()) - 1;
      var currency_symbol = $(".totals__subtotal-value").data("symbol");
      var total = parseFloat( $(".totals__subtotal-value").attr("data-total_price"));
      console.log(total);
      var price = parseFloat($(this).closest(".cart__item").find('.item__price').data("price"));
      $.post('/cart/update.js', 'updates['+variant_id+']=' + num);
      $(this).closest(".qty__content").find(".qty_num").text(num);
      $(".item__count").text(count);
      $(".totals__subtotal-value").attr("data-total_price", (total - price));
      $(".totals__subtotal-value").text(currency_symbol + (total / 100 - price / 100).toFixed(2));
    }
  })
  $(document).on("click", ".cart__item .remove_item", function(){
    var num = parseInt($(this).closest(".cart__item").find(".qty_num").text());
    var variant_id = $(this).closest(".cart__item").data("variant_id");
    var count = parseInt($(".item__count").text()) - num;
    var currency_symbol = $(".totals__subtotal-value").data("symbol");
    var total = parseFloat( $(".totals__subtotal-value").attr("data-total_price"));
    console.log(total);
    var price = parseFloat($(this).closest(".cart__item").find('.item__price').data("price"));
    $.post('/cart/update.js', 'updates['+variant_id+']=0');
    $(this).closest(".cart__item").remove();
    $(".item__count").text(count);
    $(".totals__subtotal-value").attr("data-total_price", (total - price * num));
    $(".totals__subtotal-value").text(currency_symbol + (total / 100 - price * num / 100).toFixed(2));
  })
  $(document).on("click",".product__info-wrapper .product-form__submit", function(event){
    event.preventDefault();
    var data = $(this).closest("form").serializeArray();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',           
      success: function() {
        jQuery.getJSON('/cart.js', function(cart) {
          if($('body').hasClass('customer_wholesale')){
            window.location.href = '/cart';
          }
          else{
            $('body').addClass("minicart-open");
            updateMinicart(cart);
          }
       })
      }});
  })

  $('[product-main-slider]').slick({
    dots: false,
    infinite: false,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: "[data-thumbnail-slider]"
  });

  $('[data-thumbnail-slider]').slick({
    dots: false,
    infinite: false,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: "[product-main-slider]",
    focusOnSelect: true
  });
  $('[logo-text__slider]').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    speed: 1000,
    arrows: false
  })

  $(document).on("mouseover", ".sub_level_2 a", function(){
    if($(window).width() > 1024) {
        var target = $(".mega-menu__container > .sub-menu_contents");
        var content = $(this).next(".sub_items").html();
        if (content == undefined) {
          content = "";
        }
        target.html(content);
    }
  })
  // $(document).on("mouseout", ".sub_level_2 a", function(){
  //   if($(window).width() > 1024) {
  //       var target = $(".mega-menu__container > .sub-menu_contents");
  //       target.html("");
  //   }
  // })

  $('[data-image-slider]').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    draggable: false,
    swip: false,
    arrows: false,
    fade: true
  });

  $(".hero-inner").slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
    arrows: false
  })

  $(".mulit-image_text .img_text").hover(function() {
    if(!$(this).hasClass("text_active")) {
      var index = $(".mulit-image_text .img_text").index($(this));
      var handle = $(this).data("handle");
      $("[data-image-slider]").slick('slickGoTo', index);
      $(this).closest(".image-text__wrapper").find(".img_text.text_active").removeClass("text_active");
      $(this).addClass("text_active");
    }
  })
  $(document).on("click", "a.header__icon--cart,header .bag-mobile a, button.minicart__toggle, .overlay", function(event){
    event.preventDefault();
    if($("body").hasClass("customer_wholesale")){
      window.location.href = '/cart';
    }
    else{
      $("body").toggleClass("minicart-open");
    }
  })
  $(document).on("click", ".overlay", function(event){
    event.preventDefault();
    $("body").removeClass("minicart-open");
    $("body").removeClass("collection-filter");
    $(".filter__title.active").next("ul.facets__list").slideToggle();
    $(".filter__title.active").removeClass("active");
  })

  $(document).on("click", ".minicart__item .item_minus", function() {
    var variant_id = $(this).closest(".minicart__item").attr("data-variant_id");
    var quantity = parseInt($(this).closest(".qty__content").find(".qty_num").text());
    quantity = quantity - 1;
    var data = {
      quantity: quantity,
      id: variant_id
    }
    jQuery.ajax({
      type: 'post',
      url: '/cart/change.js',
      data: data,
      success: function(){
        jQuery.getJSON('/cart.js', function(cart) {
          updateMinicart(cart);
       })
      },
      dataType: 'json'
    });
  })
  $(document).on("click", ".minicart__item .item_plus", function() {
    var variant_id = $(this).closest(".minicart__item").attr("data-variant_id");
    var quantity = parseInt($(this).closest(".qty__content").find(".qty_num").text());
    quantity = quantity + 1;
    var data = {
      quantity: quantity,
      id: variant_id
    }
    jQuery.ajax({
      type: 'post',
      url: '/cart/change.js',
      data: data,
      success: function(){
        jQuery.getJSON('/cart.js', function(cart) {
          updateMinicart(cart);
       })
      },
      dataType: 'json'
    });
  })
  $(document).on("click", ".minicart__item .remove_item", function() {
    var variant_id = $(this).closest(".minicart__item").attr("data-variant_id");
    var data = {
      quantity: 0,
      id: variant_id
    }
    jQuery.ajax({
      type: 'post',
      url: '/cart/change.js',
      data: data,
      success: function(){
        jQuery.getJSON('/cart.js', function(cart) {
          updateMinicart(cart);
       })
      },
      dataType: 'json'
    });
  })
  function updateMinicart(cart) {
    
    if (cart.item_count == 0) {
      $("#CartDrawer").addClass("drawer--inner");
      $("h3.cart__empty").removeClass("hide");
      $("#CartDrawer .minicart__body").addClass("hide");
      $("#CartDrawer .minicart__footer").addClass("hide");
      $(".minicart__freeshipping").addClass("hide");
      $(".minicart__product__upsell").addClass("hide");
      $("a.header__icon--cart .item__count").text(0);
      $(".minicart__header .minicart__total .item_num").text(0);
      // Reset data shipping bar
      $(".free-shipping-calculator__label .text-shipping").text('');
      $(".free-shipping-calculator__label .price-away").text('');
      $(".free-shipping-calculator__label .text-unlocked").text('');
      $(".totals__subtotal-value").text('');
      // $(".js-discount-code-field").slideUp();
      // $(".cart-drawer-inner").css("max-height", "calc(100vh - 175px)");
      // $("#btn-toggle-input-discount").show();
      $(".payment__afterpay afterpay-placement").attr("data-amount", '');
    } else {
      $("#CartDrawer").removeClass("drawer--inner");
      $("h3.cart__empty").addClass("hide");
      $("#CartDrawer .minicart__body").removeClass("hide");
      $(".minicart__freeshipping").removeClass("hide");
      $(".minicart__product__upsell").removeClass("hide");
      $("#CartDrawer .minicart__footer").removeClass("hide");
      
      $("a.header__icon--cart .item__count").text(cart.item_count);
      $(".minicart__header .minicart__total .item_num").text(cart.item_count);

      var currency_symbol = $(".minicart_contents").attr("data-currency_symbol");
      var line_items = cart.items;

      $(".minicart_contents").html('');
      var shipping_value = $("#free-shipping-calculator").attr('data-treshold');
      var data_text_unlocked = $("#free-shipping-calculator").attr('data-unlocked');
      var cart_total = 0;

      line_items.forEach(function(line_item) {
        $.ajax({
          type: 'GET',
          url: '/variants/' + line_item.variant_id + '.js', // Get variant info
          dataType: 'json',
          success: function(variantData) {
            var itemPriceUpdated = currency_symbol + ((line_item.final_price / 100) * line_item.quantity).toFixed(2);
            var compareAtPrice = variantData.compare_at_price ? (variantData.compare_at_price / 100) : 0;
            var totalCompareAtPrice = (compareAtPrice * line_item.quantity).toFixed(2);
            var compareAtPriceUpdated = compareAtPrice ? currency_symbol + totalCompareAtPrice : null;

            var item = '<div class="minicart__item" data-variant_id="' + line_item.id + '">';
            item += '<div class="item__image"><a href="' + line_item.url + '" class="card__image-wrapper" data-cart-item-href>';
            item += '<img class="card__image" src="' + line_item.image + '" alt="Image"></a></div>';
            item += '<div class="item__info">';
            item += '<div class="info__header"><div class="item__title">' + line_item.title + '</div>';

            item += '<div class="item__price"><span>' + itemPriceUpdated + '</span>';
            if (compareAtPriceUpdated) {
                item += '<span class="item__price__compare">' + compareAtPriceUpdated + '</span>'; 
            }
            item += '</div></div>';

            item += '<div class="info__content"><div class="qty"><span class="qty__title">QTY:</span><div class="qty__content">';
            item += '<span class="item_minus"><svg width="9" height="2" viewBox="0 0 9 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 1H9" stroke="black" stroke-width="0.5"></path></svg></span>';
            item += '<span class="qty_num">' + line_item.quantity + '</span><span class="item_plus"><svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 5H9" stroke="black" stroke-width="0.5"></path><path d="M4.5 9.5L4.5 0.5" stroke="black" stroke-width="0.5"></path></span></div></div><a class="remove_item">Remove</a></div></div></div>';
            
            // Append the item to minicart only after getting the compare_at_price
            $(".minicart_contents").append(item);

            // Update cart total
            cart_total += (line_item.final_price / 100).toFixed(2) * line_item.quantity;

            // Update total price when cart change
            $(".totals__subtotal-value").text(currency_symbol + cart_total.toFixed(2));
            // Update data amout afterpay when cart change
            $(".payment__afterpay afterpay-placement").attr("data-amount", cart_total);
            // Reset data shipping bar
            $(".free-shipping-calculator__label .text-shipping").text('');
            $(".free-shipping-calculator__label .price-away").text('');
            $(".free-shipping-calculator__label .text-unlocked").text('');

            var shipping_total = (shipping_value / 100).toFixed(2);

            if (cart_total < shipping_total) {

              var percent = ( shipping_total - cart_total).toFixed(2);

              $("#free-ship-progress").css("width", cart_total + "%").removeClass("free-ship-progress-free");
              // Reset content label shipping bar
              $(".free-shipping-calculator__label").html('');

              // Set the data shipping bar when cart change
              $(".free-shipping-calculator__label").append('<span class="text-shipping">Spend</span>');
              $(".free-shipping-calculator__label").append('<span class="price-away">'+ (currency_symbol + percent) +'</span>');
              $(".free-shipping-calculator__label").append('<span class="text-unlocked">More for Free Domestic Shipping</span>');
              
            }else {
              $("#free-ship-progress").css("width","100%").addClass("free-ship-progress-free");
              $(".free-shipping-calculator__label").html('');
              $(".free-shipping-calculator__label").append('<span class="text-shipping"> '+ data_text_unlocked +'</span>');

            }
          }
        });
      });

      // update cart payment
      if($("#CartDrawer .payment__afterpay .payment__afterpay__desc").length){
        let subTotal = parseFloat($("#CartDrawer .totals__subtotal-value").text().replace("$", ""));
        let dataAfterPay = (subTotal / 4).toFixed(2);
        $("#CartDrawer .payment__afterpay .payment__afterpay__desc span").text(" $" + dataAfterPay + " ");
      }
    }
  }
})
$(document).ready(function(){
  // update cart payment
  if($("#CartDrawer .payment__afterpay .payment__afterpay__desc").length){
    let subTotal = parseFloat($("#CartDrawer .totals__subtotal-value").text().replace("$", ""));
    let dataAfterPay = (subTotal / 4).toFixed(2);
    $("#CartDrawer .payment__afterpay .payment__afterpay__desc span").text(" $" + dataAfterPay + " ");
  }
})
// $(document).on("click", "#btn-toggle-input-discount", function() {
//   $(this).hide();
//   $(".js-discount-code-field").slideDown();
//   $(".cart-drawer-inner").css("max-height", "calc(100vh - 315px)");
// });
$(document).on("click", ".accordian__container .item_title", function(){
  if(!$(this).hasClass("open")) {
    $(".accordian__container .item_title.open").next(".item_text").slideToggle();
    $(".accordian__container .item_title.open").toggleClass("open");
  } 
  $(this).toggleClass("open");
  $(this).next(".item_text").slideToggle();
})
$(document).on("click", ".image-with-text__text .more_button", function(){
  $(this).toggleClass("open");
  $(this).closest(".image-with-text__text").find("div.more").toggleClass("hide");
  $(this).closest(".image-with-text__text").find("p.more").toggleClass("hide");
})
$(document).on("click", "[tab-header__item]", function(){
  if(!$(this).hasClass("active")) {
    $(this).closest(".tab__header").find('div').toggleClass("active");
    $(".tab__contents > div").toggleClass("hide");
  }
})
$(document).on("click", ".tab__contents button.show_more", function(){
  if(!$(this).hasClass("open")) {
    $(this).addClass("open");
    $(this).closest("div").find(".hide").addClass("show");
    $(this).closest("div").find(".show").removeClass("hide");
  } else {
    $(this).removeClass("open");
    $(this).closest("div").find(".show").addClass("hide");
    $(this).closest("div").find(".hide").removeClass("show");
  }
})
$(document).on("click", ".main__text .more_button", function(){
  $(this).closest(".main__text").find("div.more").toggleClass("hide");
  $(this).toggleClass("open");
})
$(document).on("click", ".main-blog .show_more", function(){
  if(!$(this).hasClass("open")) {
    $(this).addClass("open");
    $(this).prev(".blog-articles").find(".hide").addClass("show");
    $(this).prev(".blog-articles").find(".show").removeClass("hide");
  } else {
    $(this).removeClass("open");
    $(this).prev(".blog-articles").find(".show").addClass("hide");
    $(this).prev(".blog-articles").find(".hide").removeClass("show");
  }
})
$(document).on("click", "summary.list-menu__item", function(event){
  if($(window).width() >= 990) {
    event.preventDefault();
    return false;
  }
})
$(document).on("click", ".heading__container .heading_item", function(){
  if(!$(this).hasClass("active")) {
    // var index = $(".heading__container .heading_item").index($(this)) + 2;
    // var target = $(".complex-image_text .block__container:nth-child(" + index + ")");
    // if (target.offset() === undefined) {
    //   if(location.href.indexOf("compaign") != -1) {
    //     target = $(".simple-image-text_blocks");
    //   }
    //   if(location.href.indexOf("products") != -1) {
    //     if (index == 2) {
    //       target = $(".video-with-text");
    //     }
    //     if (index == 3) {
    //       target = $(".image_blocks-text");
    //     }
    //   }
    //   if (target.offset() === undefined) {
    //     target = $("body");
    //   }
    // }
    // $('html,body').animate({scrollTop: target.offset().top},'slow');
    $(".heading__container .heading_item.active").removeClass("active");
    $(this).addClass('active');
  }
})
$(document).on("click", "#CollectionFiltersForm .filter__title", function(){
  var is_active = false;
  if(!$(this).hasClass("active")) {
    is_active = false;
  } else {
    is_active = true;
    $("body").removeClass("collection-filter");
  }
  $("#CollectionFiltersForm .filter__title.active").next("ul.facets__list").slideToggle();
  $("#CollectionFiltersForm .filter__title.active").toggleClass("active");
  if(is_active) {
    $("body").removeClass("collection-filter");
  } else {
    $(this).next("ul.facets__list").slideToggle();
    $("body").addClass("collection-filter");
    $(this).toggleClass("active");
  }
})
$(document).on("mousedown", "ul.facets__list li", function(){
  setTimeout(function(){
    var current_url = location.href;
    $("#CollectionFiltersForm .facets__wrapper input").each(function(){
      if($(this).prop("checked")) {
        if(current_url.indexOf($(this).val()) == -1) {
          if(current_url.indexOf("filter-") == -1) {
            if(current_url.indexOf("?") == -1) {
              current_url += "/" + $(this).val();
            } else {
              current_url = current_url.replace("?", "/" + $(this).val() + "?");
            }
          }
          else {
            if(current_url.indexOf("?") == -1) {
              current_url += "+" + $(this).val();
            } else {
              current_url = current_url.replace("?","+" + $(this).val() + "?");
            }
          }
        }
      } else {
        if(current_url.indexOf($(this).val())  != -1) {
          if(current_url.indexOf("+") == -1) {
            current_url = current_url.replace("/" + $(this).val(), "");
          } else {
            if(current_url.indexOf($(this).val()) > current_url.lastIndexOf("+")) {
              current_url = current_url.replace("+" + $(this).val(), "");
            } else {
              current_url = current_url.replace($(this).val() + "+", "");
            }
          }
        }
      }
    })
    window.history.replaceState({ path: current_url }, "", current_url);
  }, 400)
})
$(document).on("click", ".product__accordion summary", function(event){
  event.preventDefault();
  if($(this).closest("details").is("[open]")) {
    $(this).closest("details").removeAttr("open");
  } else {
    $(this).closest(".product__info-container").find(".product__accordion").find("details").removeAttr("open");
    $(this).closest("details").attr("open", "");
  }
})
$(document).on("click", ".page--about-us .deferred-media__poster-button svg", function(){
    $(this).closest(".banner__box").addClass("hide");
    $(this).closest(".banner__box").prev("video").attr("autoplay", "");
    $(this).closest(".banner__box").prev("video").removeClass("hide");
})
$(document).on("click", ".product-thumbnail", function(){
  var index = $(this).data("slick-index");
  $('[data-thumbnail-slider]').slick("slickGoTo", index);
})